__turbopack_context__.v({
  "CustomerInput": "Register-module__94NbSW__CustomerInput",
  "CustomerInputButton": "Register-module__94NbSW__CustomerInputButton",
  "CustomerInputField": "Register-module__94NbSW__CustomerInputField",
  "CustomerInputLink": "Register-module__94NbSW__CustomerInputLink",
  "CustomerInputPara": "Register-module__94NbSW__CustomerInputPara",
  "HeaderPart": "Register-module__94NbSW__HeaderPart",
  "Register": "Register-module__94NbSW__Register",
  "RegisterForm": "Register-module__94NbSW__RegisterForm",
  "RegisterFormLogo": "Register-module__94NbSW__RegisterFormLogo",
  "ValidationError": "Register-module__94NbSW__ValidationError",
  "ValidationErrorLabel": "Register-module__94NbSW__ValidationErrorLabel",
  "form_part": "Register-module__94NbSW__form_part",
  "text": "Register-module__94NbSW__text",
});
